import React from "react";
import Facts from "components/Facts";

import { addRoundedRect, borderRadius } from "../svgUtils";

const width = 180;
const height = 80;
const containingRadius = Math.sqrt(width * width + height * height) / 2;
const gap = 2;

function getPieSegmentPath(
  cx,
  cy,
  innerRadius,
  outerRadius,
  startAngleRads,
  endAngleRads
) {
  const startAngle = (startAngleRads * 180) / Math.PI;
  const endAngle = (endAngleRads * 180) / Math.PI;
  const largeArcFlag = endAngle - startAngle <= 180 ? "0" : "1";

  const x1 = cx + outerRadius * Math.cos(startAngleRads);
  const y1 = cy + outerRadius * Math.sin(startAngleRads);

  const x2 = cx + outerRadius * Math.cos(endAngleRads);
  const y2 = cy + outerRadius * Math.sin(endAngleRads);

  const x3 = cx + innerRadius * Math.cos(endAngleRads);
  const y3 = cy + innerRadius * Math.sin(endAngleRads);

  const x4 = cx + innerRadius * Math.cos(startAngleRads);
  const y4 = cy + innerRadius * Math.sin(startAngleRads);

  return [
    "M",
    x1,
    y1,
    "A",
    outerRadius,
    outerRadius,
    0,
    largeArcFlag,
    1,
    x2,
    y2,
    "L",
    x3,
    y3,
    "A",
    innerRadius,
    innerRadius,
    0,
    largeArcFlag,
    0,
    x4,
    y4,
    "Z",
  ].join(" ");
}

const innerWidth = 100;
const pieInnerRadius = 10;
const pieOuterRadius = 50;
const borderColor = "black";

export default {
  layout: { radius: containingRadius },
  render: {
    enter: (item) => {
      const { elem: e, label } = item;

      item.page = 0;
      item.pageText = [""];
      item.updatePageText = () => item.midText.text(item.pageText[item.page]);
      item.pageTimer = window.setInterval(() => {
        item.page = (item.page + 1) % item.pageText.length;
        item.updatePageText();
      }, 5000);

      e.append("rect")
        .attr("x", innerWidth * -0.5 - pieInnerRadius)
        .attr("y", (pieInnerRadius + pieOuterRadius) * -0.5)
        .attr("width", innerWidth + pieInnerRadius * 2)
        .attr("height", pieInnerRadius + pieOuterRadius)
        .attr("stroke-width", "1")
        .attr("stroke", borderColor)
        .attr("fill", "white");

      item.midText = e
        .append("text")
        .attr("text-anchor", "middle")
        .attr("y", "1")
        .attr("style", "font-size: 8pt")
        .attr("dominant-baseline", "middle");

      e.append("path")
        .attr(
          "d",
          getPieSegmentPath(
            innerWidth * -0.5,
            0,
            pieInnerRadius,
            pieOuterRadius,
            Math.PI * 0.5,
            Math.PI * 1.5
          )
        )
        .attr("fill", "white")
        .attr("stroke", borderColor);

      e.append("path")
        .attr(
          "d",
          getPieSegmentPath(
            innerWidth * 0.5,
            0,
            pieInnerRadius,
            pieOuterRadius,
            Math.PI * -0.5,
            Math.PI * 0.5
          )
        )
        .attr("fill", "white")
        .attr("stroke", borderColor);

      item.l1 = e.append("path");
      item.l2 = e.append("path");
      item.l3 = e.append("path");
      item.r1 = e.append("path");
      item.r2 = e.append("path");
      item.r3 = e.append("path");
      item.r4 = e.append("path");

      e.append("text")
        .text("cpu")
        .attr("style", "mix-blend-mode: difference")
        .attr("text-anchor", "end")
        .attr("dominant-baseline", "middle")
        .attr(
          "transform",
          `translate(${innerWidth * -0.5} 0) rotate(60) translate(-20 0)`
        )
        .attr("fill", "white");

      e.append("text")
        .text("i/o")
        .attr("style", "mix-blend-mode: difference")
        .attr("text-anchor", "end")
        .attr("dominant-baseline", "middle")
        .attr("transform", `translate(${innerWidth * -0.5 - 20} 0)`)
        .attr("fill", "white");

      e.append("text")
        .text("log")
        .attr("style", "mix-blend-mode: difference")
        .attr("text-anchor", "end")
        .attr("dominant-baseline", "middle")
        .attr(
          "transform",
          `translate(${innerWidth * -0.5} 0) rotate(-60) translate(-20 0)`
        )
        .attr("fill", "white");

      e.append("text")
        .text("mem")
        .attr("style", "mix-blend-mode: difference; font-size: 8pt")
        .attr("text-anchor", "start")
        .attr("dominant-baseline", "middle")
        .attr(
          "transform",
          `translate(${innerWidth * 0.5} 0) rotate(-67.5) translate(20 0)`
        )
        .attr("fill", "white");

      e.append("text")
        .text("xtp")
        .attr("style", "mix-blend-mode: difference; font-size: 8pt")
        .attr("text-anchor", "start")
        .attr("dominant-baseline", "middle")
        .attr(
          "transform",
          `translate(${innerWidth * 0.5} 0) rotate(-22.5) translate(20 0)`
        )
        .attr("fill", "white");

      e.append("text")
        .text("wrk")
        .attr("style", "mix-blend-mode: difference; font-size: 8pt")
        .attr("text-anchor", "start")
        .attr("dominant-baseline", "middle")
        .attr(
          "transform",
          `translate(${innerWidth * 0.5} 0) rotate(22.5) translate(20 0)`
        )
        .attr("fill", "white");

      e.append("text")
        .text("sess")
        .attr("style", "mix-blend-mode: difference; font-size: 8pt")
        .attr("text-anchor", "start")
        .attr("dominant-baseline", "middle")
        .attr(
          "transform",
          `translate(${innerWidth * 0.5} 0) rotate(67.5) translate(20 0)`
        )
        .attr("fill", "white");

      addRoundedRect(
        e,
        innerWidth * -0.5 + gap,
        -pieOuterRadius,
        innerWidth * 0.5 - gap,
        pieOuterRadius - pieInnerRadius,
        borderRadius,
        1
      )
        .attr("fill", "white")
        .attr("stroke", borderColor);
      item.qrySec = e
        .append("text")
        .text("?")
        .attr("x", innerWidth * -0.25 + gap / 2)
        .attr("y", (pieOuterRadius + pieInnerRadius) * -0.5 - 2)
        .attr("text-anchor", "middle")
        .attr("fill", "black");
      e.append("text")
        .text("qry/sec")
        .attr("x", innerWidth * -0.25 + gap / 2)
        .attr("y", (pieOuterRadius + pieInnerRadius) * -0.5 + 2)
        .attr("text-anchor", "middle")
        .attr("dominant-baseline", "hanging")
        .attr("style", "font-size: 8pt")
        .attr("fill", "black");

      addRoundedRect(
        e,
        gap / 2,
        -pieOuterRadius,
        innerWidth * 0.5 - gap,
        pieOuterRadius - pieInnerRadius,
        borderRadius,
        1
      )
        .attr("fill", "white")
        .attr("stroke", borderColor);
      item.plans = e
        .append("text")
        .text("?")
        .attr("x", innerWidth * 0.25 - gap / 2)
        .attr("y", (pieOuterRadius + pieInnerRadius) * -0.5 - 2)
        .attr("text-anchor", "middle")
        .attr("fill", "black");
      e.append("text")
        .text("plans")
        .attr("x", innerWidth * 0.25 - gap / 2)
        .attr("y", (pieOuterRadius + pieInnerRadius) * -0.5 + 2)
        .attr("text-anchor", "middle")
        .attr("dominant-baseline", "hanging")
        .attr("style", "font-size: 8pt")
        .attr("fill", "black");

      addRoundedRect(
        e,
        innerWidth * -0.5 + gap,
        pieInnerRadius,
        innerWidth * 0.5 - gap,
        pieOuterRadius - pieInnerRadius,
        borderRadius,
        1
      )
        .attr("fill", "white")
        .attr("stroke", borderColor);
      item.msAvg = e
        .append("text")
        .text("?")
        .attr("x", innerWidth * -0.25 + gap / 2)
        .attr("y", (pieOuterRadius + pieInnerRadius) * 0.5)
        .attr("text-anchor", "middle")
        .attr("fill", "black");
      e.append("text")
        .text("ms avg")
        .attr("x", innerWidth * -0.25 + gap / 2)
        .attr("y", (pieOuterRadius + pieInnerRadius) * 0.5 + 4)
        .attr("text-anchor", "middle")
        .attr("dominant-baseline", "hanging")
        .attr("style", "font-size: 8pt")
        .attr("fill", "black");

      addRoundedRect(
        e,
        gap / 2,
        pieInnerRadius,
        innerWidth * 0.5 - gap,
        pieOuterRadius - pieInnerRadius,
        borderRadius,
        1
      )
        .attr("fill", "white")
        .attr("stroke", borderColor);
      item.msMax = e
        .append("text")
        .text("?")
        .attr("x", innerWidth * 0.25 - gap / 2)
        .attr("y", (pieOuterRadius + pieInnerRadius) * 0.5)
        .attr("text-anchor", "middle")
        .attr("fill", "black");
      e.append("text")
        .text("ms max")
        .attr("x", innerWidth * 0.25 - gap / 2)
        .attr("y", (pieOuterRadius + pieInnerRadius) * 0.5 + 4)
        .attr("text-anchor", "middle")
        .attr("dominant-baseline", "hanging")
        .attr("style", "font-size: 8pt")
        .attr("fill", "black");

      item.header = e
        .append("text")
        .attr("y", -pieOuterRadius - 4)
        .attr("text-anchor", "middle")
        .attr("style", "font-size: 11pt");

      item.footer = e
        .append("text")
        .attr("y", pieOuterRadius + 3)
        .attr("text-anchor", "middle")
        .attr("dominant-baseline", "hanging")
        .attr("style", "font-size: 8pt");

      (item.updateFromData = () => {
        if (!item.data) return;
        const dataObj = JSON.parse(item.data);
        item.header.text(dataObj.database);

        let s = dataObj.server;

        // if contains ':', remove anything up to and including it
        const i = s.indexOf(":");
        if (i >= 0) {
          s = s.substring(i + 1);
        }

        // if contains ',', remove it and everything after
        const j = s.indexOf(",");
        if (j >= 0) {
          s = s.substring(0, j);
        }

        item.footer.text(s);
      })();
    },
    update: (item) => {
      item.updateFromData();
    },
    exit: (item) => {
      window.clearInterval(item.pageTimer);
    },
  },
  eventHandlers: {
    status: (item, data, ui) => {
      const dataObj = JSON.parse(data);

      function secBetween(d1, d2) {
        // format of d1/d2: "2023-02-21T16:26:00+00:00"
        const t1 = new Date(d1);
        const t2 = new Date(d2);
        return (t2 - t1) / 1000;
      }

      function doSlice(i, x, v, b, e) {
        const c = (b + e) / 2;
        b = b * 0.9 + c * 0.1;
        e = e * 0.9 + c * 0.1;
        i.attr(
          "d",
          getPieSegmentPath(
            innerWidth * x,
            0,
            pieInnerRadius + 1,
            Math.max(v * (pieOuterRadius - 1), pieInnerRadius + 2),
            Math.PI * b,
            Math.PI * e
          )
        ).attr("fill", v < 0.5 ? "green" : v < 0.8 ? "orange" : "red");
      }

      doSlice(
        item.l1,
        -0.5,
        dataObj.resources.avg_cpu_percent / 100.0,
        0.5,
        0.8333
      );
      doSlice(
        item.l2,
        -0.5,
        dataObj.resources.avg_data_io_percent / 100.0,
        0.8333,
        1.1666
      );
      doSlice(
        item.l3,
        -0.5,
        dataObj.resources.avg_log_write_percent / 100.0,
        1.1666,
        1.5
      );

      doSlice(
        item.r1,
        0.5,
        dataObj.resources.avg_memory_usage_percent / 100.0,
        -0.5,
        -0.25
      );
      doSlice(
        item.r2,
        0.5,
        dataObj.resources.xtp_storage_percent / 100.0,
        -0.25,
        0
      );
      doSlice(
        item.r3,
        0.5,
        dataObj.resources.max_worker_percent / 100.0,
        0,
        0.25
      );
      doSlice(
        item.r4,
        0.5,
        dataObj.resources.max_session_percent / 100.0,
        0.25,
        0.5
      );

      item.pageText = [
        `${dataObj.tables.rows.toLocaleString()} rows`,
        `${dataObj.tables.tables.toLocaleString()} tables`,
        `${(
          Math.round(dataObj.storage.total_space_mb * 10) / 10
        ).toLocaleString()} MB total`,
        `${(
          Math.round(dataObj.storage.used_space_mb * 10) / 10
        ).toLocaleString()} MB used`,
      ];
      item.updatePageText();

      item.qrySec.text(
        (
          Math.round(
            (10 * dataObj.queries.executions) /
              secBetween(dataObj.queries.start_time, dataObj.queries.stamp)
          ) / 10
        ).toLocaleString()
      );
      item.plans.text(dataObj.queries.plans.toLocaleString());

      item.msAvg.text(Math.round(10 * dataObj.queries.avg_ms) / 10);
      item.msMax.text(Math.round(10 * dataObj.queries.max_ms) / 10);
    },
  },
  renderInfoHead: (t) => t.data || "(No full name)",
  renderInfoBody: (t) => (
    <Facts>
      <Facts.Fact label="Data" value={t.data || ""} />
    </Facts>
  ),
};
